import MobileDetect from 'mobile-detect';

/**
 * Function to check if the user is accessing the app from a mobile device.
 * @returns {boolean} - Returns `true` if the device is mobile, otherwise `false`.
 */
export function isMobileDevice() {
    const md = new MobileDetect(window.navigator.userAgent);
    return md.mobile() !== null; // Returns true if a mobile device is detected
}

/**
 * Function to restrict or allow access based on the current route.
 * @param {string} route - The current route path.
 * @returns {boolean} - Returns `true` if access is restricted, otherwise `false`.
 */
export function detectMobile(route) {
    const isMobile = isMobileDevice();

    // Allow access to /survey/* routes on mobile
    if (isMobile && route.startsWith('/survey/')) {
        return false; // Allow mobile access for survey pages
    }

    // Restrict mobile access for other routes
    if (isMobile) {
        const body = document.createElement('div');
        body.style.textAlign = 'center';
        body.style.marginTop = '20%';
        body.style.fontFamily = 'Arial, sans-serif';
        body.innerHTML = `
            <h2 style="color: #1E2742;">This application is only accessible on desktop devices.</h2>
            <p>Please switch to a laptop or desktop to use this site.</p>
        `;
        document.body.innerHTML = ''; // Clear existing content
        document.body.appendChild(body); // Add the new message
        return true; // Restrict access
    }

    return false; // No restriction for desktop devices
}
